import { auth } from '../components/firebase';

const API_BASE_URL = process.env.REACT_APP_B_KEND;

async function getAuthHeaders() {
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) {
        throw new Error('User not authenticated');
    }
    const token = await user.getIdToken(true);
    const correlationId = crypto.randomUUID();
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'X-Correlation-ID': correlationId,
    };
}

class ApiService {
    constructor(baseURL) {
        this.baseURL = baseURL;
    }

    getDefaultCharacterSettings() {
        return {
            firstName: '',
            lastName: '',
            characterName: '',
            skinTone: 'fair',
            hairStyle: 'buzzhair',
            hairColour: 'black',
            bookSelected: '',
            bookMessage: '',
        };
    }

    async handleResponse(response) {
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            const errorMessage =
                errorData.message || 'An error occurred while processing your request.';
            const error = new Error(errorMessage);
            error.response = errorData;
            throw error;
        }
        return response.json();
    }

    async updateUsersCharacter(characterSettings) {
        const headers = await getAuthHeaders();
        const response = await fetch(`${this.baseURL}/osthardcoveruser`, {
            method: 'POST',
            headers,
            body: JSON.stringify(characterSettings),
        });
        return this.handleResponse(response);
    }

    async getAvatar() {
        const headers = await getAuthHeaders();
        const response = await fetch(`${this.baseURL}/avatar`, {
            method: 'GET',
            headers,
        });
        return this.handleResponse(response);
    }

    async updateAvatar(avatarSettings) {
        const headers = await getAuthHeaders();
        const { email: _email, ...bodyWithoutEmail } = avatarSettings;
        const response = await fetch(`${this.baseURL}/avatar`, {
            method: 'PUT',
            headers,
            body: JSON.stringify(bodyWithoutEmail),
        });
        return this.handleResponse(response);
    }
}

export { getAuthHeaders };

const apiService = new ApiService(API_BASE_URL);
export default apiService;
